// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/distribution/distribution.proto" (package "mlmbox.client.distribution", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Distribution } from "./distribution.ts";
import type { Distribution_Holder } from "../../types/distribution.ts";
import type { AttachSignedMessageRequest } from "./distribution.ts";
import type { SignatureMessageResponse } from "./distribution.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Distribution_State } from "../../types/distribution.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.distribution.Distribution
 */
export interface IDistributionClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Distribution.State);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_State>;
    /**
     * @generated from protobuf rpc: GetSignatureMessage(google.protobuf.Empty) returns (mlmbox.client.distribution.SignatureMessageResponse);
     */
    getSignatureMessage(input: Empty, options?: RpcOptions): UnaryCall<Empty, SignatureMessageResponse>;
    /**
     * @generated from protobuf rpc: Web3AddressAttachSigned(mlmbox.client.distribution.AttachSignedMessageRequest) returns (mlmbox.types.Distribution.State);
     */
    web3AddressAttachSigned(input: AttachSignedMessageRequest, options?: RpcOptions): UnaryCall<AttachSignedMessageRequest, Distribution_State>;
    /**
     * @generated from protobuf rpc: Web3AddressDetach(google.protobuf.Empty) returns (mlmbox.types.Distribution.State);
     */
    web3AddressDetach(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_State>;
    /**
     * @generated from protobuf rpc: HolderInfo(google.protobuf.Empty) returns (mlmbox.types.Distribution.Holder);
     */
    holderInfo(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_Holder>;
}
/**
 * @generated from protobuf service mlmbox.client.distribution.Distribution
 */
export class DistributionClient implements IDistributionClient, ServiceInfo {
    typeName = Distribution.typeName;
    methods = Distribution.methods;
    options = Distribution.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Distribution.State);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_State> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Distribution_State>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSignatureMessage(google.protobuf.Empty) returns (mlmbox.client.distribution.SignatureMessageResponse);
     */
    getSignatureMessage(input: Empty, options?: RpcOptions): UnaryCall<Empty, SignatureMessageResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, SignatureMessageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Web3AddressAttachSigned(mlmbox.client.distribution.AttachSignedMessageRequest) returns (mlmbox.types.Distribution.State);
     */
    web3AddressAttachSigned(input: AttachSignedMessageRequest, options?: RpcOptions): UnaryCall<AttachSignedMessageRequest, Distribution_State> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AttachSignedMessageRequest, Distribution_State>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Web3AddressDetach(google.protobuf.Empty) returns (mlmbox.types.Distribution.State);
     */
    web3AddressDetach(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_State> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Distribution_State>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HolderInfo(google.protobuf.Empty) returns (mlmbox.types.Distribution.Holder);
     */
    holderInfo(input: Empty, options?: RpcOptions): UnaryCall<Empty, Distribution_Holder> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Distribution_Holder>("unary", this._transport, method, opt, input);
    }
}
